import React, { useState, createContext, useContext } from 'react';
import AuthenticationService from '../services/authentication-service';

const AuthContext = createContext(null);

export const AuthProvider = ({children}) => {
    const [isAuth, setAuth] = useState(false);
    
    /** ------------------------------------
     * Method : authLogin
     * Description : Set user is authenticated
     */
    const authLogin = () => {
        setAuth(true);
    }

    /** ------------------------------------
     * Method : authLogout
     * Description : Set user is not authenticated
     */
    const authLogout = async () => {
        setAuth(false);
        await AuthenticationService.logout();
    }

    return (
        <AuthContext.Provider value = {{isAuth, authLogin, authLogout}}>
            {children}
        </AuthContext.Provider>
    )
}

export const useAuth = () => useContext(AuthContext);
